module.exports = __webpack_public_path__ + "img/redLight.ee843bc2.svg";